/* eslint-disable no-unused-vars */
interface IMongoQuery {
  $text?: any;
  docType?: string;
  date?: any
}

interface IOpenSearchQuery {
  scroll?: string;
  index: string;
  body: {
    from: number;
    size?: number;
    query: any;
    aggs?: any;
  };
}

export const buildCaseQuery = (searchVal: string, docType: string, startDt: string, endDt: string): IMongoQuery => {
  if (searchVal && docType) {
    const query: IMongoQuery = {
      $text: {
        $search: searchVal
      },
      docType: docType,
      // date:{
      //   $gte: startDt,
      //   $lte: endDt,
      // }
    };
    return query;
  }
  if (searchVal) {
    const query: IMongoQuery = {
      $text: {
        $search: searchVal
      },
      // date:{
      //   $gte: startDt,
      //   $lte: endDt,
      // }
    };
    return query;
  }
  if (docType) {
    const query: IMongoQuery = {
      docType: docType,
      // date:{
      //   $gte: startDt,
      //   $lte: endDt,
      // }
    };
    return query;
  }
  const query: IMongoQuery = {
    // date:{
    //   $gte: startDt,
    //   $lte: endDt,
    // }
  };
  return query;
};

export const multiIndexQuery = (pageNum: number, resultsPerPage: number, formVals: any): IOpenSearchQuery => {
  const pageOffset = 1;
  const query: IOpenSearchQuery = {
    index: formVals.indices,
    body: {
      from: (pageNum - pageOffset) * resultsPerPage,
      size: resultsPerPage,
      query: {
        query_string: {
          query: formVals.searchText
        }
      },
      aggs: {
        byindex: {
          terms: {
            field: '_index',
            size: 100,
          },
        },
      },
    }
  };
  return query;
};
